module.exports = __webpack_public_path__ + "img/logo.2130f6a0.png";